// extracted by mini-css-extract-plugin
export default {"container":"SearchPage_container__kZN35","to":"SearchPage_to__4TUfX"};